import { render, staticRenderFns } from "./milestone-plan-onboarding-dialog-content--second-page.vue?vue&type=template&id=2a69df42&scoped=true&"
import script from "./milestone-plan-onboarding-dialog-content--second-page.vue?vue&type=script&lang=ts&"
export * from "./milestone-plan-onboarding-dialog-content--second-page.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-plan-onboarding-dialog-content--second-page.vue?vue&type=style&index=0&id=2a69df42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69df42",
  null
  
)

export default component.exports